module.exports = __webpack_public_path__ + "img/xsmsHead.08476c0e.png";